export default {
    name: 'qesg-dash-card-props',
    props: {
        title: {
            type: String,
            required: false,
            default: (titleProps) => typeof titleProps === 'undefined' ? '(title)' : titleProps
        },
        titleClass: {
            type: [String, Array, Object],
            required: false
        }
    }
}